import { getAccountsSummaryCount  , getGroupWiseAccountsCount} from "../types/admin_analytics_types";

export const getAccountsSummaryCountRequest = (payload, cb) => ({
  type: getAccountsSummaryCount.GET_ACCOUNTS_SUMMARY_COUNT_REQUEST,
  payload,
  cb,
});
export const getAccountsSummaryCountSuccess = (payload) => ({
  type: getAccountsSummaryCount.GET_ACCOUNTS_SUMMARY_COUNT_SUCCESS,
  payload,
});
export const getAccountsSummaryCountError = (payload) => ({
  type: getGroupWiseAccountsCount.GET_GROUP_WISE_ACCOUNTS_COUNT_ERROR,
  payload,
});

export const getGroupWiseAccountsCountRequest = (payload, cb) => ({
  type: getGroupWiseAccountsCount.GET_GROUP_WISE_ACCOUNTS_COUNT_REQUEST,
  payload,
  cb,
});
export const getGroupWiseAccountsCountSuccess = (payload) => ({
  type: getGroupWiseAccountsCount.GET_GROUP_WISE_ACCOUNTS_COUNT_SUCCESS,
  payload,
});
export const getGroupWiseAccountsCountError = (payload) => ({
  type: getGroupWiseAccountsCount.GET_GROUP_WISE_ACCOUNTS_COUNT_ERROR,
  payload,
});
